import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Flex, Button } from '@sopranodesign/pulse-components';

const SmartLink = ({ to, label, ...props }) => {
  const isExternal = /^https?:\/\//.test(to);

  const buttonProps = {
    variant: 'secondary',
    icon: 'archive',
    ...props,
  };

  const button = <Button {...buttonProps}>{label}</Button>;

  return isExternal ? (
    <a href={to} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
      {button}
    </a>
  ) : (
    <Button as={Link} to={to} {...buttonProps}>
      {label}
    </Button>
  );
};

SmartLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const GenerativeAiDocumentScope = ({ content }) => {
  const { type = '', name = '', source_link = '' } = content;

  const label = (() => {
    switch (type) {
      case 'file':
        return `File (${name})`;
      case 'sitemap':
        return `Sitemap (${name})`;
      default:
        return name;
    }
  })();

  return (
    <Flex start>
      {source_link ? (
        <SmartLink to={source_link} label={label} />
      ) : type === '' ? (
        `This file has been deleted (${name})`
      ) : (
        name
      )}
    </Flex>
  );
};

GenerativeAiDocumentScope.propTypes = {
  content: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string,
    source_link: PropTypes.string,
  }).isRequired,
};

export default GenerativeAiDocumentScope;
